// Comprehensive timezone list with common timezones
const createTimezone = (offset, name) => {
    const displayName = name.replace(/_/g, " ");
    const normalizedOffset =
        offset === "UTC" ? "UTC" : offset.startsWith("GMT") ? offset : `GMT${offset}`;
    const value = `${name} (${normalizedOffset})`;
    return {
        value,
        label: `(${normalizedOffset}) ${displayName}`,
        offset: normalizedOffset,
        name,
        zone: name,
        timezone: normalizedOffset,
    };
};

export const TIMEZONES = [
    createTimezone("GMT-12:00", "Etc/GMT-12"),
    createTimezone("GMT-11:00", "Etc/GMT-11"),
    createTimezone("GMT-11:00", "Pacific/Midway"),
    createTimezone("GMT-10:00", "America/Adak"),
    createTimezone("GMT-09:00", "America/Anchorage"),
    createTimezone("GMT-09:00", "Pacific/Gambier"),
    createTimezone("GMT-08:00", "America/Dawson_Creek"),
    createTimezone("GMT-08:00", "America/Ensenada"),
    createTimezone("GMT-08:00", "America/Los_Angeles"),
    createTimezone("GMT-07:00", "America/Chihuahua"),
    createTimezone("GMT-07:00", "America/Denver"),
    createTimezone("GMT-06:00", "America/Belize"),
    createTimezone("GMT-06:00", "America/Cancun"),
    createTimezone("GMT-06:00", "America/Chicago"),
    createTimezone("GMT-06:00", "Chile/EasterIsland"),
    createTimezone("GMT-05:00", "America/Bogota"),
    createTimezone("GMT-05:00", "America/Havana"),
    createTimezone("GMT-05:00", "America/New_York"),
    createTimezone("GMT-04:30", "America/Caracas"),
    createTimezone("GMT-04:00", "America/Campo_Grande"),
    createTimezone("GMT-04:00", "America/Glace_Bay"),
    createTimezone("GMT-04:00", "America/Goose_Bay"),
    createTimezone("GMT-04:00", "America/Santiago"),
    createTimezone("GMT-04:00", "America/La_Paz"),
    createTimezone("GMT-03:00", "America/Argentina/Buenos_Aires"),
    createTimezone("GMT-03:00", "America/Montevideo"),
    createTimezone("GMT-03:00", "America/Araguaina"),
    createTimezone("GMT-03:00", "America/Godthab"),
    createTimezone("GMT-03:00", "America/Miquelon"),
    createTimezone("GMT-03:00", "America/Sao_Paulo"),
    createTimezone("GMT-03:30", "America/St_Johns"),
    createTimezone("GMT-02:00", "America/Noronha"),
    createTimezone("GMT-01:00", "Atlantic/Cape_Verde"),
    createTimezone("GMT", "Europe/Belfast"),
    createTimezone("GMT", "Africa/Abidjan"),
    createTimezone("GMT", "Europe/Dublin"),
    createTimezone("GMT", "Europe/Lisbon"),
    createTimezone("GMT", "Europe/London"),
    createTimezone("UTC", "UTC"),
    createTimezone("GMT+01:00", "Africa/Algiers"),
    createTimezone("GMT+01:00", "Africa/Windhoek"),
    createTimezone("GMT+01:00", "Atlantic/Azores"),
    createTimezone("GMT+01:00", "Atlantic/Stanley"),
    createTimezone("GMT+01:00", "Europe/Amsterdam"),
    createTimezone("GMT+01:00", "Europe/Belgrade"),
    createTimezone("GMT+01:00", "Europe/Brussels"),
    createTimezone("GMT+02:00", "Africa/Cairo"),
    createTimezone("GMT+02:00", "Africa/Blantyre"),
    createTimezone("GMT+02:00", "Asia/Beirut"),
    createTimezone("GMT+02:00", "Asia/Damascus"),
    createTimezone("GMT+02:00", "Asia/Gaza"),
    createTimezone("GMT+02:00", "Asia/Jerusalem"),
    createTimezone("GMT+03:00", "Africa/Addis_Ababa"),
    createTimezone("GMT+03:00", "Asia/Riyadh89"),
    createTimezone("GMT+03:00", "Europe/Minsk"),
    createTimezone("GMT+03:30", "Asia/Tehran"),
    createTimezone("GMT+04:00", "Asia/Dubai"),
    createTimezone("GMT+04:00", "Asia/Yerevan"),
    createTimezone("GMT+04:00", "Europe/Moscow"),
    createTimezone("GMT+04:30", "Asia/Kabul"),
    createTimezone("GMT+05:00", "Asia/Tashkent"),
    createTimezone("GMT+05:30", "Asia/Kolkata"),
    createTimezone("GMT+05:45", "Asia/Katmandu"),
    createTimezone("GMT+06:00", "Asia/Dhaka"),
    createTimezone("GMT+06:00", "Asia/Yekaterinburg"),
    createTimezone("GMT+06:30", "Asia/Rangoon"),
    createTimezone("GMT+07:00", "Asia/Bangkok"),
    createTimezone("GMT+07:00", "Asia/Novosibirsk"),
    createTimezone("GMT+08:00", "Etc/GMT+8"),
    createTimezone("GMT+08:00", "Asia/Hong_Kong"),
    createTimezone("GMT+08:00", "Asia/Krasnoyarsk"),
    createTimezone("GMT+08:00", "Australia/Perth"),
    createTimezone("GMT+08:45", "Australia/Eucla"),
    createTimezone("GMT+09:00", "Asia/Irkutsk"),
    createTimezone("GMT+09:00", "Asia/Seoul"),
    createTimezone("GMT+09:00", "Asia/Tokyo"),
    createTimezone("GMT+09:30", "Australia/Adelaide"),
    createTimezone("GMT+09:30", "Australia/Darwin"),
    createTimezone("GMT+09:30", "Pacific/Marquesas"),
    createTimezone("GMT+10:00", "Etc/GMT+10"),
    createTimezone("GMT+10:00", "Australia/Brisbane"),
    createTimezone("GMT+10:00", "Australia/Hobart"),
    createTimezone("GMT+10:00", "Asia/Yakutsk"),
    createTimezone("GMT+10:30", "Australia/Lord_Howe"),
    createTimezone("GMT+11:00", "Asia/Vladivostok"),
    createTimezone("GMT+11:30", "Pacific/Norfolk"),
    createTimezone("GMT+12:00", "Etc/GMT+12"),
    createTimezone("GMT+12:00", "Asia/Anadyr"),
    createTimezone("GMT+12:00", "Asia/Magadan"),
    createTimezone("GMT+12:00", "Pacific/Auckland"),
    createTimezone("GMT+12:45", "Pacific/Chatham"),
    createTimezone("GMT+13:00", "Pacific/Tongatapu"),
    createTimezone("GMT+14:00", "Pacific/Kiritimati"),
];

// Function to get current timezone
export const getCurrentTimezone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Function to format timezone for display
export const formatTimezoneDisplay = (timezone) => {
    const timezoneObj = TIMEZONES.find(tz => tz.zone === timezone);
    return timezoneObj ? timezoneObj.label : timezone;
};

// Function to get timezone offset
export const getTimezoneOffset = (timezone) => {
    const now = new Date();
    const utc = new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
    const targetTime = new Date(utc.toLocaleString("en-US", { timeZone: timezone }));
    const offset = (targetTime.getTime() - utc.getTime()) / (1000 * 60 * 60);
    return offset;
};

// Function to get timezone abbreviation
export const getTimezoneAbbreviation = (timezone) => {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en', {
        timeZone: timezone,
        timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(now);
    const timeZoneName = parts.find(part => part.type === 'timeZoneName');
    return timeZoneName ? timeZoneName.value : timezone;
};

export const getTimezoneZone = (timezone) => {
    const timezoneObj = TIMEZONES.find(tz => tz.zone === timezone);
    return timezoneObj ? timezoneObj.timezone : timezone;
};